import React from 'react'
import styled from 'styled-components'
import HRule from '../../atoms/HRule'
import { Text, View } from '@olxbr/design-system'
import Link from '../../atoms/Link'
import { secretWordLink } from '../../../settings/staticUrl'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
`

const BlockText = styled(Text)`
  size: title4;
  padding-bottom: 12px;
  padding-top: 17px;
  weight: bold;
`

const HRuleWrapper = styled(View)`
  margin-top: 14px;
  margin-bottom: 14px;
`

const Suggestion = styled(Text)`
  font-size: 14px;
  font-weight: 400;
`

class SecretWordBlock extends React.Component {
  onChangeSecretWordClick = event => {
    const { onChangeSecretWord } = this.props
    if (onChangeSecretWord && typeof onChangeSecretWord === 'function') {
      onChangeSecretWord()
    }
  }

  render() {
    return (
      <Content>
        <Text size="title3" weight="bold">
          Palavra Secreta
        </Text>
        <Text size="caption" color="grayscale.darker">
          Essa é sua palavra de segurança para identificar se o e-mail recebido de confirmação de
          compra ou venda é oficial OLX.
        </Text>

        <BlockText>
          <Text size="title4" weight="bold">
            {this.props.secretWord}
          </Text>
        </BlockText>

        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>

        <Suggestion>
          Deseja mudar a sua palavra?{' '}
          <Link
            type="primary"
            underline={false}
            href={secretWordLink + '?email=' + this.props.email}
            onClick={this.onChangeSecretWordClick}
            preventHrefOnClick={false}
          >
            Alterar
          </Link>
        </Suggestion>
      </Content>
    )
  }
}

export default SecretWordBlock
